<template>

	<widget title="Search Employees/Projects/Services" icon="fa-search"  :max-height="maxHeight">
		<search-bar 
			v-on:submit="search"
			v-on:clearSearch="clearSearch" 
			placeholder="Search directory for people..." 
			:full-width="true">
		</search-bar>

		<table-list
			v-if="compiledResults.length > 0"
			:records="compiledResults"
			:fields="fields"
			record-name="Result"
			:clickable-row="true"
			:has-edit="true"
			id-field="slug"
			edit-button-text="View"
			edit-button-icon="fa fa-eye"
			v-on:edit="viewResult">
		</table-list>
	</widget>

</template>

<script>
import TableList from "../TableList"
import SearchBar from "../SearchBar"
import Widget from "../Widget"

export default {
	components: {
		TableList,
		SearchBar,
		Widget
	},
	props: ["maxHeight"],
	data() {
		return {
			users: [],
			projects: [],
			services: [],
			searchTerms: "",
			fields: [
				{label: "Name",key:"recordName",type:"link"},
				{label: "Type", key:"type"},
				{label: "",key:"extraInfo"}
			]
		}
	},
	computed: {
		compiledResults() {
			let results = [] 

			results = this.users.map(user => {
				user.recordName = {
					text: user.first_name+" "+user.last_name,
					link: "/employee/"+user.slug+"/profile"
				}

				user.type = "Employee"
				user.extraInfo = user.email

				return user
			})

			results = results.concat(this.services.map(service => {

				let customerName = ""
				if ("Customer" in service && service.Customer)
					customerName = service.Customer.name
				else if ("customer_name_cache" in service)
					customerName = service.customer_name_cache

				service.recordName = {
					text: "#"+service.job_num+": "+customerName,
					link: "/service/"+service.slug+"/dashboard"
				}
				service.type = "Service"
				service.extraInfo = service.job_name

				return service
			}))

			results = results.concat(this.projects.map(job => {
				job.recordName = {
					text: "#"+job.job_num+": "+job.job_name,
					link: "/project/"+job.slug+"/dashboard"
				}
				job.type = "Project"
				job.extraInfo = job.Customer.name

				return job
			}))

			//24765

			return results
		}
	},
	methods: {
		search(terms) {
			let vm = this

			vm.spinner("true")

			terms = encodeURIComponent(terms)

			let userParams = {
				filters: [
					["first_name",terms,"and","like"],
					["last_name",terms,"or","like"],
					["address",terms,"or","like"],
					["city",terms,"or","like"],
					["phone",terms,"or","like"],
					["email",terms,"or","like"]
				],
				include: ["EmployeeClassification"]
			}

			let jobParams = {
				fields: ["id","slug","job_num","job_name","Customer"],
				filters: [
					["job_name",terms,"and","like"],
					["job_num",terms,"or","like"]
				],
				include: [{model:"Contact",fields:["id","slug","name"]}]
			}

			let promises = [
				vm.getJSON("User/get",userParams),
				vm.getJSON("Job/get",jobParams),
				vm.getJSON("Service/get",jobParams)
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[0].success)
					vm.users = responses[0].data

				if (responses[1].success)
					vm.projects = responses[1].data

				if (responses[2].success)
					vm.services = responses[2].data
			})
		},
		viewResult(result) {
			if (result.type == "Service")
				this.$router.push("/service/"+result.slug+"/dashboard")

			else if (result.type == "Project")
				this.$router.push("/project/"+result.slug+"/dashboard")

			else if (result.type == "Employee")
				this.$router.push("/employee/"+result.slug+"/profile")
		},
		clearSearch() {
			this.users = []
			this.projects = []
			this.services = []
		}
	}

}
</script>

<style>

	h2 {
		font-size: 20pt;
		color: #455A64 
	}

	.card .card-header h3 {
		margin: 0;
		text-decoration: none;
	}
</style>
